export default __webpack_public_path__ + "static/media/img-gtl-klm@2x.afc7c651.png";